<template>
    <search-list :show-search-results-heading="showSearchResultsHeading" :location-link="locationLink"></search-list>
</template>

<script>
    import SearchList from '@/components/SiteSearch/search-list'

    export default {
        components: {
            SearchList
        },

        props: {
            locationLink: {
                default: null,
                type: String
            },

            showSearchResultsHeading: {
                default: false,
                type: Boolean
            }
        }
    }
</script>